function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,570H540.43a20,20,0,0,0,20-20V330a40,40,0,0,0-40-40H279.57a40,40,0,0,0-40,40V510",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,330V530a40,40,0,0,1-40,40h0a40,40,0,0,1-40-40V170a20,20,0,0,1,20-20h83.64a20,20,0,0,1,18.73,13l12.77,34a20,20,0,0,0,18.72,13h167a40,40,0,0,1,40,40v40H279.57A40,40,0,0,0,239.57,330Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCases);
export default __webpack_public_path__ + "static/media/cases.e7bd4e73e9224c7364ec6393c50a967d.svg";
export { ForwardRef as ReactComponent };